(function () {
  /* ---------- announcement rotator ---------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-apdp-ann]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var track = root.querySelector('[data-apdp-ann-track]');
      if (!track || track.children.length < 2) return;
      var delay = parseInt(root.getAttribute('data-interval'), 10) || 4000;
      var i = 0;
      setInterval(function () {
        i = (i + 1) % track.children.length;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
      }, delay);
    });
  }

  /* ---------- gallery ---------- */
  function setActiveThumb(root, index) {
    root.querySelectorAll('[data-apdp-thumb]').forEach(function (el, i) {
      el.classList.toggle('active', i === index);
    });
  }

  function currentSlide(track) {
    if (!track || !track.children.length) return 0;
    var w = track.children[0].getBoundingClientRect().width || 1;
    return Math.max(0, Math.min(Math.round(track.scrollLeft / w), track.children.length - 1));
  }

  function goToSlide(root, index) {
    var track = root.querySelector('[data-apdp-gallery-track]');
    if (!track || !track.children.length) return;
    var n = Math.max(0, Math.min(index, track.children.length - 1));
    track.scrollTo({ left: (track.children[0].getBoundingClientRect().width || 0) * n, behavior: 'smooth' });
    setActiveThumb(root, n);
  }

  /* ---------- quantity ---------- */
  function getQty(root) {
    var el = root.querySelector('[data-apdp-qty-value]');
    return Math.max(1, parseInt(el && el.textContent, 10) || 1);
  }

  function setQty(root, q) {
    var el = root.querySelector('[data-apdp-qty-value]');
    if (el) el.textContent = Math.max(1, q);
    syncPack(root);
  }

  /* ---------- pack selection -> CTAs, price, offers, sticky ---------- */
  function money(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function setStickyValues(bar, d) {
    var now = bar.querySelector('[data-apdp-sticky-now]');
    var was = bar.querySelector('[data-apdp-sticky-was]');
    var save = bar.querySelector('[data-apdp-sticky-save]');
    if (now) now.textContent = money(d.price);
    if (was) {
      if (d.compare > d.price) {
        was.textContent = money(d.compare);
        was.parentNode.style.display = '';
      } else {
        was.textContent = '';
        was.parentNode.style.display = 'none';
      }
    }
    if (save) {
      if (d.compare > d.price) {
        var suffix = bar.getAttribute('data-save-suffix') || 'today!';
        save.textContent = 'Save ' + money(d.compare - d.price) + ' ' + suffix;
      } else {
        save.textContent = '';
      }
    }
    bar.querySelectorAll('[data-apdp-cta]').forEach(function (btn) {
      btn.setAttribute('data-variant', d.variant);
      btn.setAttribute('data-qty', d.qty);
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.setAttribute('href', base.replace(/\/$/, '') + '/cart/' + d.variant + ':' + d.qty);
    });
  }

  function syncPack(root) {
    var picked = root.querySelector('[data-apdp-pack]:checked');
    if (!picked) return;

    var variant = picked.getAttribute('data-variant');
    var qty = getQty(root);
    var price = parseInt(picked.getAttribute('data-price'), 10) || 0;
    var compare = parseInt(picked.getAttribute('data-compare'), 10) || 0;
    var name = picked.getAttribute('data-name') || '';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = base.replace(/\/$/, '') + '/cart/' + variant + ':' + qty;

    // headline price
    var nowEl = root.querySelector('[data-apdp-price-now]');
    var wasEl = root.querySelector('[data-apdp-price-was]');
    if (nowEl) nowEl.textContent = money(price);
    if (wasEl) {
      if (compare > price) {
        wasEl.textContent = money(compare);
        wasEl.style.display = '';
      } else {
        wasEl.style.display = 'none';
      }
    }

    // buttons
    root.querySelectorAll('[data-apdp-cta]').forEach(function (btn) {
      btn.setAttribute('href', url);
      btn.setAttribute('data-variant', variant);
      btn.setAttribute('data-qty', qty);
    });

    // sticky bar mirrors the selection
    document.querySelectorAll('[data-apdp-sticky]').forEach(function (bar) {
      setStickyValues(bar, { variant: variant, qty: qty, price: price, compare: compare });
      var sel = bar.querySelector('[data-apdp-sticky-select]');
      if (sel && sel.value !== String(variant)) sel.value = String(variant);
    });

    updateOffers(root, price * qty);
  }

  /* ---------- offer progress ---------- */
  function updateOffers(root, cartPaise) {
    var wrap = root.querySelector('[data-apdp-offer]');
    if (!wrap) return;
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('.apdp-offer-dot[data-threshold]'));
    if (!dots.length) return;
    var stops = dots
      .map(function (d) {
        return {
          el: d,
          t: parseInt(d.getAttribute('data-threshold'), 10) || 0,
          pos: parseFloat(d.getAttribute('data-pos')) || 0,
          name: d.getAttribute('data-unlock') || ''
        };
      })
      .sort(function (a, b) {
        return a.t - b.t;
      });

    // Piecewise scale: the fill reaches each dot exactly at its threshold.
    var last = stops[stops.length - 1];
    var progress = 100;
    if (cartPaise < last.t) {
      var v0 = 0, p0 = 0;
      for (var i = 0; i < stops.length; i++) {
        if (cartPaise <= stops[i].t) {
          var span = stops[i].t - v0;
          progress = p0 + (span > 0 ? (cartPaise - v0) / span : 1) * (stops[i].pos - p0);
          break;
        }
        v0 = stops[i].t;
        p0 = stops[i].pos;
      }
    }
    var fill = wrap.querySelector('[data-apdp-offer-fill]');
    if (fill) fill.style.width = Math.max(0, Math.min(100, progress)) + '%';

    var next = null;
    stops.forEach(function (s) {
      var on = cartPaise >= s.t;
      s.el.classList.toggle('unlocked', on);
      if (!on && !next) next = s;
    });

    var status = wrap.querySelector('[data-apdp-offer-status]');
    if (status) {
      status.textContent = next
        ? (wrap.getAttribute('data-status') || '[amount] to unlock [reward]')
            .replace('[amount]', money(next.t - cartPaise))
            .replace('[reward]', next.name)
        : wrap.getAttribute('data-done') || 'All offers unlocked';
    }
  }

  /* ---------- add to cart / buy now (Shopflo-aware) ----------
     Shopflo's bundle exposes handleFloBuyNowBtn(event) — clears the cart,
     adds the product form's items and opens Shopflo checkout — and
     handleFloCartBtn(event), which opens the Shopflo cart drawer.
     Shopflo.openFloCart / openFloCheckout exist too but need a URL, so they
     are not used here. The bundle is "live" once it has attached openFloCart
     (flo-checkout-guard defines stand-ins before that). */
  function shopfloLive() {
    return !!(window.Shopflo && typeof window.Shopflo.openFloCart === 'function');
  }

  function fakeEvent(form) {
    return { preventDefault: function () {}, stopPropagation: function () {}, target: { form: form } };
  }

  function shopfloBuyNow(variant, qty) {
    if (!shopfloLive() || typeof window.handleFloBuyNowBtn !== 'function') return false;
    var form = document.getElementById('apdp-flo-buynow');
    if (!form) {
      form = document.createElement('form');
      form.id = 'apdp-flo-buynow';
      form.method = 'post';
      form.action = '/cart/add';
      form.hidden = true;
      form.innerHTML = '<input type="hidden" name="id"><input type="hidden" name="quantity">';
      document.body.appendChild(form);
    }
    form.querySelector('[name="id"]').value = variant;
    form.querySelector('[name="quantity"]').value = qty;
    try {
      window.handleFloBuyNowBtn(fakeEvent(form));
      return true;
    } catch (e) {
      return false;
    }
  }

  function openShopfloCart() {
    if (!shopfloLive() || typeof window.handleFloCartBtn !== 'function') return false;
    try {
      window.handleFloCartBtn(fakeEvent(null));
      return true;
    } catch (e) {
      return false;
    }
  }

  function addToCart(btn, thenCheckout) {
    var variant = btn.getAttribute('data-variant');
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!variant) return false;

    // Buy now: hand the selected pack straight to Shopflo checkout.
    if (thenCheckout && shopfloBuyNow(variant, qty)) return true;

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.setAttribute('aria-busy', 'true');

    fetch(base.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.removeAttribute('aria-busy');
        // Add to cart opens the Shopflo cart; without the bundle fall back
        // to Shopify's own cart / checkout pages.
        if (thenCheckout) window.location.href = '/checkout';
        else {
          refreshCartCount();
          if (!openShopfloCart()) window.location.href = '/cart';
        }
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = btn.getAttribute('href');
      });
    return true;
  }

  /* ---------- sticky visibility ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-apdp-sticky]');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';

    var buyBox = document.querySelector('[data-apdp-buybox]');

    function update() {
      var vh = window.innerHeight || 0;
      // Visible from the very top; only steps aside while the page's own
      // Buy Now button is on screen.
      var show = true;
      var primary = document.querySelector('.apdp-btn--buy') || buyBox;
      if (primary) {
        var r = primary.getBoundingClientRect();
        var onScreen = r.top < vh * 0.92 && r.bottom > vh * 0.08;
        show = !onScreen;
      }
      if (show === bar.classList.contains('is-visible')) return;
      bar.classList.toggle('is-visible', show);
    }

    function measure() {
      document.documentElement.style.setProperty('--scta-h', bar.offsetHeight + 'px');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function(){ measure(); onScroll(); }, { passive: true });
    measure();
    update();
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-apdp-cta][data-mode="cart"]');
    if (cta) {
      if (addToCart(cta, cta.getAttribute('data-checkout') === 'true')) e.preventDefault();
      return;
    }

    var thumb = e.target.closest('[data-apdp-thumb]');
    if (thumb) {
      var gr = thumb.closest('[data-apdp-hero]');
      if (gr) goToSlide(gr, parseInt(thumb.getAttribute('data-index'), 10) || 0);
      return;
    }

    var arrow = e.target.closest('[data-apdp-arrow]');
    if (arrow) {
      var hr = arrow.closest('[data-apdp-hero]');
      if (!hr) return;
      var tr = hr.querySelector('[data-apdp-gallery-track]');
      goToSlide(hr, currentSlide(tr) + (arrow.getAttribute('data-dir') === 'prev' ? -1 : 1));
      return;
    }

    var qtyBtn = e.target.closest('[data-apdp-qty]');
    if (qtyBtn) {
      var qr = qtyBtn.closest('[data-apdp-hero]');
      if (!qr) return;
      setQty(qr, getQty(qr) + (qtyBtn.getAttribute('data-dir') === 'down' ? -1 : 1));
      return;
    }

    var revLink = e.target.closest('[data-apdp-scroll-reviews]');
    if (revLink) {
      e.preventDefault();
      scrollToReviews();
    }
  });

  /* "N verified reviews" link -> the Judge.me reviews customers can actually see.
     Prefers a visible Judge.me widget (app block or snippet), falls back to #reviews.
     Re-aims a few times because lazy images above can push the reviews down
     while the page is scrolling. */
  function findReviewsTarget() {
    // 1) a Judge.me reviews widget that is actually showing (not a hidden snippet copy)
    var widgets = document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget');
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      if (w.offsetHeight > 40 && getComputedStyle(w).display !== 'none') return w;
    }
    // 2) our own reviews section, if it is in use
    var own = document.querySelector('[data-apdp-reviews]');
    if (own && own.offsetHeight > 40) return own;
    // 3) the plain #reviews anchor
    var a = document.getElementById('reviews');
    return a ? a.parentElement : null;
  }
  function scrollToReviews() {
    var head = document.querySelector('[data-apdp-head].is-sticky');
    var offset = (head ? head.offsetHeight : 0) + 12;
    var target = findReviewsTarget();
    if (!target) return;

    // Load the lazy images between here and the reviews now, so they don't
    // push the reviews further down while we are scrolling.
    var tTop = target.getBoundingClientRect().top + window.pageYOffset;
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.getBoundingClientRect().top + window.pageYOffset < tTop) img.loading = 'eager';
    });

    var aim = function (smooth) {
      var t = findReviewsTarget();
      if (!t) return;
      var y = t.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    };
    aim(true);

    // Keep re-aiming until the page settles (max ~5s); stop if the visitor scrolls.
    var stopped = false, stable = 0, ticks = 0;
    var stop = function () { stopped = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, stop, { once: true, passive: true });
    });
    var timer = setInterval(function () {
      ticks++;
      var t = findReviewsTarget();
      if (stopped || !t || ticks > 20) { clearInterval(timer); return; }
      var off = t.getBoundingClientRect().top - offset;
      if (Math.abs(off) > 16) { stable = 0; if (ticks > 3) aim(false); }
      else if (++stable >= 3) clearInterval(timer);
    }, 250);
  }

  document.addEventListener('change', function (e) {
    var stickySel = e.target.closest('[data-apdp-sticky-select]');
    if (stickySel) {
      var id = stickySel.value;
      var radio = document.querySelector('[data-apdp-pack][data-variant="' + id + '"]');
      if (radio) {
        radio.checked = true;
        var host = radio.closest('[data-apdp-hero]');
        if (host) syncPack(host);
      }
      return;
    }

    var pack = e.target.closest('[data-apdp-pack]');
    if (pack) {
      var root = pack.closest('[data-apdp-hero]');
      if (root) syncPack(root);
    }
  });

  /* ---------- testimonial rail: dots follow scroll ---------- */
  function initRails() {
    document.querySelectorAll('[data-apdp-rail-root]').forEach(function (root) {
      var rail = root.querySelector('[data-apdp-rail]');
      var dotWrap = root.querySelector('[data-apdp-rail-dots]');
      if (!rail || rail.dataset.bound) return;
      rail.dataset.bound = '1';

      var dots = dotWrap ? Array.prototype.slice.call(dotWrap.children) : [];
      var cards = Array.prototype.slice.call(rail.children);

      function currentIndex() {
        var left = rail.scrollLeft;
        var best = 0;
        var min = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - rail.offsetLeft - left);
          if (d < min) {
            min = d;
            best = i;
          }
        });
        if (left >= rail.scrollWidth - rail.clientWidth - 2) best = cards.length - 1;
        return best;
      }

      function paint() {
        var i = currentIndex();
        dots.forEach(function (b, j) {
          b.classList.toggle('active', j === i);
        });
      }

      function hideDotsIfAllVisible() {
        if (dotWrap) dotWrap.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      }

      dots.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0;
          rail.scrollTo({ left: cards[i].offsetLeft - rail.offsetLeft - pad, behavior: 'smooth' });
        });
      });

      var ticking = false;
      rail.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            paint();
            ticking = false;
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', function () {
        hideDotsIfAllVisible();
        paint();
      });
      hideDotsIfAllVisible();
      paint();
    });
  }

  /* ---------- accordions: one open at a time ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-apdp-acc-group]').forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = '1';
      var items = Array.prototype.slice.call(group.querySelectorAll('details'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });
  }

  /* ---------- UGC video rail ---------- */
  /* Own UGC cards act as a fallback: once an app block in the same section
     (e.g. Quinn shoppable videos) has rendered real cards, hide ours. */
  function watchUgcFallback() {
    document.querySelectorAll('[data-apdp-ugc-fallback]').forEach(function (own) {
      if (own.dataset.watching) return;
      own.dataset.watching = '1';
      var app = own.closest('[data-apdp-ugc]').querySelector('.apdp-ugc-app');
      if (!app) return;
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        var loaded = app.querySelector('.quinn_card:not(.quinn_card_loading), video, img');
        if (loaded && app.getBoundingClientRect().height > 80) {
          own.hidden = true;
          clearInterval(t);
        } else if (tries > 40) {
          clearInterval(t);
        }
      }, 500);
    });
  }

  function initUgc() {
    watchUgcFallback();
    document.querySelectorAll('[data-apdp-ugc]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var rail = root.querySelector('[data-apdp-ugc-rail]');
      if (!rail) return;
      var prev = root.querySelector('[data-apdp-ugc-prev]');
      var next = root.querySelector('[data-apdp-ugc-next]');

      function step() {
        var card = rail.querySelector('.apdp-ugc-card');
        if (!card) return 220;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function paint() {
        var max = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint);
      paint();

      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-ugc-video]'));
      function play(v) {
        v.muted = !v.closest('.apdp-ugc-card').classList.contains('is-unmuted');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      if (root.getAttribute('data-autoplay') === 'true' && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting && en.intersectionRatio >= 0.6) play(en.target);
              else en.target.pause();
            });
          },
          { threshold: [0, 0.6] }
        );
        videos.forEach(function (v) { io.observe(v); });
      }

      // Tap a video to play/pause it (always works, autoplay or not).
      videos.forEach(function (v) {
        v.addEventListener('click', function () {
          if (v.paused) play(v);
          else v.pause();
        });
      });

      root.querySelectorAll('[data-apdp-ugc-sound]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.apdp-ugc-card');
          var v = card.querySelector('video');
          if (!v) return;
          var unmute = !card.classList.contains('is-unmuted');
          // only one card plays sound at a time
          root.querySelectorAll('.apdp-ugc-card.is-unmuted').forEach(function (c) {
            c.classList.remove('is-unmuted');
            var cv = c.querySelector('video');
            if (cv) cv.muted = true;
          });
          card.classList.toggle('is-unmuted', unmute);
          v.muted = !unmute;
          if (unmute) play(v);
        });
      });
    });
  }

  /* ---------- customer reviews pagination ---------- */
  function initReviews() {
    document.querySelectorAll('[data-apdp-reviews]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('.apdp-rev-item'));
      var nav = root.querySelector('[data-apdp-rev-pages]');
      var per = parseInt(root.getAttribute('data-per-page'), 10) || 5;
      var pages = Math.ceil(items.length / per);
      if (!nav || pages <= 1) return;
      var page = 1;

      function btn(label, target, aria, cls) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.setAttribute('data-page', target);
        if (aria) b.setAttribute('aria-label', aria);
        if (cls) b.className = cls;
        return b;
      }
      function render(scroll) {
        items.forEach(function (it, i) {
          it.hidden = Math.floor(i / per) + 1 !== page;
        });
        nav.innerHTML = '';
        if (page > 1) nav.appendChild(btn('‹', page - 1, 'Previous page'));
        for (var p = 1; p <= pages; p++) {
          var b = btn(String(p), p, 'Page ' + p, p === page ? 'active' : '');
          if (p === page) b.setAttribute('aria-current', 'page');
          nav.appendChild(b);
        }
        if (page < pages) {
          nav.appendChild(btn('›', page + 1, 'Next page'));
          nav.appendChild(btn('»', pages, 'Last page'));
        }
        if (scroll) {
          var list = root.querySelector('[data-apdp-rev-list]');
          if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-page]');
        if (!b) return;
        page = parseInt(b.getAttribute('data-page'), 10) || 1;
        render(true);
      });
      render(false);
    });
  }

  /* ---------- buy-box testimonial carousel (infinite, auto) ---------- */
  function initTestiCarousel() {
    document.querySelectorAll('[data-apdp-tcar]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var track = root.querySelector('[data-apdp-tcar-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var n = slides.length;
      if (n < 2) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-tcar-dot]'));
      var delay = parseInt(root.getAttribute('data-interval'), 10) || 5000;

      // A clone of the first slide at the end makes the loop seamless.
      var clone = slides[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      track.appendChild(clone);

      var i = 0, timer = null, paused = false;
      function place(animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + -i * 100 + '%)';
        dots.forEach(function (d, j) {
          d.classList.toggle('active', j === i % n);
        });
        if (!animate) void track.offsetWidth; // flush so the next move animates
      }
      function go(to) {
        if (to < 0) {
          i = n;
          place(false);
          to = n - 1;
        }
        i = to;
        place(true);
      }
      track.addEventListener('transitionend', function () {
        if (i >= n) {
          i = 0;
          place(false);
        }
      });
      function start() {
        stop();
        timer = setInterval(function () {
          if (!paused && !document.hidden) go(i + 1);
        }, delay);
      }
      function stop() {
        if (timer) clearInterval(timer);
      }
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () {
          go(j);
          start();
        });
      });
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; paused = true; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        paused = false;
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) {
          go(dx < 0 ? i + 1 : i - 1);
          start();
        }
      });
      place(false);
      start();
    });
  }

  /* ---------- horizontal product rail (suggested products) ---------- */
  function initHRails() {
    document.querySelectorAll('[data-apdp-hrail]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var rail = root.querySelector('[data-apdp-hrail-track]');
      if (!rail) return;
      var prev = root.querySelector('[data-apdp-hrail-prev]');
      var next = root.querySelector('[data-apdp-hrail-next]');
      function step() {
        var c = rail.firstElementChild;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return c ? c.getBoundingClientRect().width + gap : 260;
      }
      function paint() {
        var max = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
        root.classList.toggle('is-static', max <= 0);
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    });
  }

  /* ---------- brand header ---------- */
  function refreshCartCount() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-apdp-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = !c.item_count;
        });
      })
      .catch(function () {});
  }
  window.apdpRefreshCartCount = refreshCartCount;

  function initHeader() {
    var head = document.querySelector('[data-apdp-head]');
    if (!head || head.dataset.bound) return;
    head.dataset.bound = '1';

    // An app script sets body{overflow:auto} inline, which turns <body> into a
    // scroll box and breaks every position:sticky element. Clear only that
    // value; "hidden" (cart/drawer scroll lock) is left alone.
    function unblockSticky() {
      var o = document.body.style.overflow;
      if (o === 'auto' || o === 'scroll') document.body.style.overflow = '';
    }
    unblockSticky();
    if ('MutationObserver' in window) {
      new MutationObserver(unblockSticky).observe(document.body, { attributes: true, attributeFilter: ['style'] });
    }

    function setH() {
      var sticky = head.classList.contains('is-sticky');
      document.documentElement.style.setProperty('--apdp-head-h', sticky ? head.offsetHeight + 'px' : '0px');
    }
    setH();
    window.addEventListener('resize', setH);
    window.addEventListener('scroll', function () {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });

    var drawer = head.querySelector('[data-apdp-head-drawer]');
    var opener = head.querySelector('[data-apdp-head-open]');
    function openDrawer(open) {
      if (!drawer) return;
      drawer.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (opener) opener.setAttribute('aria-expanded', String(open));
      if (open) {
        var f = drawer.querySelector('a,summary,button');
        if (f) f.focus();
      } else if (opener) opener.focus();
    }
    if (opener) opener.addEventListener('click', function () { openDrawer(true); });
    head.querySelectorAll('[data-apdp-head-close]').forEach(function (b) {
      b.addEventListener('click', function () { openDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && !drawer.hidden) openDrawer(false);
    });

    var sBtn = head.querySelector('[data-apdp-head-search]');
    var sBar = head.querySelector('[data-apdp-head-searchbar]');
    if (sBtn && sBar) {
      sBtn.addEventListener('click', function () {
        sBar.hidden = !sBar.hidden;
        sBtn.setAttribute('aria-expanded', String(!sBar.hidden));
        setH();
        if (!sBar.hidden) sBar.querySelector('input[type=search]').focus();
      });
    }

    // Cart icon opens the Shopflo cart; falls back to /cart without it.
    var cartLink = head.querySelector('[data-apdp-head-cart]');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        if (openShopfloCart()) e.preventDefault();
      });
    }
  }

  /* ---------- promo countdown (Offer ends in hh mm ss) ---------- */
  function initPromoTimer() {
    document.querySelectorAll('[data-apdp-timer]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var mode = el.getAttribute('data-mode') || 'midnight';
      var IST = 330 * 60 * 1000; // IST is UTC+5:30, the store's timezone
      var end;

      function nextMidnightIST(now) {
        var ist = new Date(now + IST);
        ist.setUTCHours(24, 0, 0, 0);
        return ist.getTime() - IST;
      }
      if (mode === 'fixed') {
        var m = (el.getAttribute('data-end') || '').match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/);
        end = m ? Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) - IST : 0;
      } else if (mode === 'rolling') {
        var hours = parseInt(el.getAttribute('data-hours'), 10) || 12;
        var key = 'apdp-offer-end';
        try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) { end = 0; }
        if (!end || end <= Date.now()) {
          end = Date.now() + hours * 3600 * 1000;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
        }
      }

      var hEl = el.querySelector('[data-apdp-t="h"]');
      var mEl = el.querySelector('[data-apdp-t="m"]');
      var sEl = el.querySelector('[data-apdp-t="s"]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };

      function tick() {
        var now = Date.now();
        if (mode === 'midnight' && (!end || end <= now)) end = nextMidnightIST(now);
        var left = Math.max(0, Math.floor((end - now) / 1000));
        if (mode === 'fixed' && left === 0) { el.hidden = true; return false; }
        var h = Math.floor(left / 3600);
        hEl.textContent = pad(h);
        mEl.textContent = pad(Math.floor((left % 3600) / 60));
        sEl.textContent = pad(left % 60);
        return true;
      }
      if (tick()) {
        var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000);
      }
    });
  }

  function init() {
    initPromoTimer();
    initHeader();
    initTestiCarousel();
    initHRails();
    initReviews();
    initAnnouncement();
    initSticky();
    initRails();
    initAccordions();
    initUgc();
    document.querySelectorAll('[data-apdp-hero]').forEach(function (root) {
      syncPack(root);
      var track = root.querySelector('[data-apdp-gallery-track]');
      if (!track || track.dataset.bound) return;
      track.dataset.bound = '1';
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            setActiveThumb(root, currentSlide(track));
            ticking = false;
          });
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
